import { parseDataTransform } from '@acme/common'
import TabbedDialog from 'global/guides/Dialog/TabbedDialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useMemo } from 'react'
import {
    Outlet,
    useNavigate,
    useOutletContext,
    useParams,
    useSearchParams,
} from 'react-router-dom'
import { Empresa, empresas, updateEmpresaSchema } from 'service/api'
import { toast } from 'sonner'
import { tabs } from '../constants/tabs'

export default function EdicaoEmpresa() {
    const [searchParam] = useSearchParams()
    const navigate = useNavigate()
    const { empresaId } = useParams()
    const { mutateAsync, isLoading } = empresas.mutations.useUpdate({
        invalidateQuery: true,
    })

    const tab = searchParam.get('aba')
    const voltar = searchParam.get('voltar')

    const company = useOutletContext<{ data: Empresa[] }>()?.data?.find(
        item => item.id === +empresaId!,
    )!

    function handleSubmit(data: Empresa) {
        return mutateAsync(data, {
            onSuccess: () => {
                toast.success('Empresa atualizada com sucesso!')
            },
            onError: ({ statusCode, message }) => {
                if (statusCode === 422) {
                    ;(message as string[]).forEach(error => toast.error(error))
                } else {
                    toast.error(message)
                }
            },
        })
    }

    const prev = useMemo(() => company, [])

    function handleClose() {
        if (voltar) return navigate(voltar + '?aba=adicionais')
        else if (!prev.cnpj || !prev.cidadeId)
            return navigate('/cadastros/empresas')
        navigate(-1)
    }

    return (
        <TabbedDialog.Root
            loading={isLoading}
            onClose={handleClose}
            onSubmit={handleSubmit}
            open={hasPermission(['update', 'Empresas'])}
            tabs={tabs}
            defaultTab={tab || undefined}
            schema={updateEmpresaSchema}
            defaultValues={{
                ...parseDataTransform(company, {
                    dateFormat: 'toString',
                }),
                uf: company.Cidade?.uf,
                competenciaAtual: company.competenciaAtual,
                proximoFechamentoPonto: company.proximoFechamentoPonto,
                periodoFechamentoPonto: Number(company.periodoFechamentoPonto),
                layoutFolha: company.layoutFolha,
                tipoDescontoDSR: company.tipoDescontoDSR,
                atrasoDescontoDSR: company.atrasoDescontoDSR,
            }}
        >
            <TabbedDialog.Title>Editar empresa</TabbedDialog.Title>
            <TabbedDialog.Content dividers />
            <TabbedDialog.Actions>
                <TabbedDialog.Actions.SecondaryButton />
                <TabbedDialog.Actions.PrimaryButton closeOnSubmit />
            </TabbedDialog.Actions>
            <Outlet context={{ data: company }} />
        </TabbedDialog.Root>
    )
}

export function useEditarEmpresaOutletContext() {
    return useOutletContext<{ data: Empresa }>()
}
